import React from 'react';
import {Link} from "react-router-dom";

let perPersonPrice = (per_person_price, fee) => {
    let admission_fees_male = per_person_price + (per_person_price  * fee / 100) + 0.30 + ((per_person_price + (per_person_price  * fee / 100)) * 0.029);
    return Math.ceil(admission_fees_male);
}

const deals = (props) => {
    return (
          <div key={props.deal._id} className="col-12 col-sm-4 col-md-4 spacing-all-category">
              <div className={props.deal.is_bumped ? "category-box-outer deals-highlight" : "category-box-outer"}>
                  <div className="offers-tag-outer">
                      <ul className="list-unstyled mb-0">
                          {props.deal.badges.map( badge => {
                              return <li key={badge._id}><img src={badge.image_full} alt="specialdeals"/></li>
                          })}
                      </ul>
                  </div>
                  <div className="category-box-header">
                      <img src={props.deal.image} alt={props.deal.name}/>
                      {props.deal.is_bumped && <div className="featured-deal">Featured</div>}
                      <div className="like--done">
                          <button className=""><i onClick={() => props.handleFavourite(props.index)} className={props.deal.is_favourite ? 'fa fa-heart fill-toggle' : 'fa fa-heart-o fill-toggle'}></i></button>
                      </div>
                  </div>
                  <Link to={`${process.env.PUBLIC_URL}/allday/deal/`+props.deal._id}>
                  <div className="category-box-body">
                      <p className="category-box-body-title d-inline-block">{props.deal.category.name}</p>
                      {props.deal.rating > 0 &&
                      <p className="dealbox-rating-count">
                        <span className="viewall-rating-title">
                           <span className="viewall-rating-count rating_bg_green">
                            <img src={`${process.env.PUBLIC_URL}/image/star.png`} alt="star-rate"/>
                            <span className="star-text">{props.deal.rating}</span>
                           </span>
                        </span>
                      </p>
                      }
                      <div className="vendor-text w-100">
                          <p className="category-box-body-subtitle custom-height w-100">{props.deal.name}</p>
                      </div>
                      <p className="category-box-body-subtitle custom-height w-100">{props.deal.subtitle}</p>
                  </div>
                  <div className="category-box-footer">
                      {props.deal.deal_price_type==='oneday' ?
                          (
                              <React.Fragment>
                                  <div className="both-deal-reserve-outer">
                                      <ul className="list-unstyled">
                                          <li>Full price : <span className="both-deal-reserve-amount">${props.deal.consumer_order_cost}</span></li>
                                          <li>Still owed : <span className="both-deal-reserve-amount">${props.deal.consumerprice}</span></li>
                                      </ul>
                                  </div>
                                  <div className="paydeposit-outer">
                                      <ul className="list-unstyled d-flex">
                                        <li><img src={`${process.env.PUBLIC_URL}/image/reserve-logo.png`} alt="paydepositdeal-silverbackHost-logo"/>Price</li>
                                        <li className="ml-auto"><span>${props.deal.consumer_order_cost-props.deal.consumerprice}</span></li>
                                      </ul>
                                 </div>
                              </React.Fragment>
                          ) : (
                              <div className="paydeposit-outer">
                                  <ul className="list-unstyled d-flex">
                                      <li><img src={`${process.env.PUBLIC_URL}/image/reserve-logo.png`} alt="paydepositdeal-silverbackHost-logo"/>Price</li>
                                      <li className="ml-auto"><span>${perPersonPrice(props.deal.consumer_admission_fees_male, props.deal.commission)}</span></li>
                                  </ul>
                              </div>
                          ) }
                  </div>
                  </Link>
              </div>
          </div>
    )
}

export default deals;